const errorRoutes = [
  {
    path: '403',
    name: '403',
    meta: {
      title: 'Forbidden',
      nav: false
    },
    component: resolve => require(['../views/error/403-error.vue'], resolve)
  },
  {
    path: '404',
    name: '404',
    meta: {
      title: 'Not Found',
      nav: false
    },
    component: resolve => require(['../views/error/404-error.vue'], resolve)
  },
  {
    path: '500',
    name: '500',
    meta: {
      title: 'INTERNAL SERVER ERROR',
      nav: false
    },
    component: resolve => require(['../views/error/500-error.vue'], resolve)
  }
]

export default errorRoutes
